
const CompanyAddress = require('./CompanyAddress.jsx');
const CompanyContactInfo = require('./CompanyContactInfo.jsx');
const Logo = require('./Logo.jsx');
const Name = require('../utility/Name.jsx');
const Separator = require('./Separator.jsx');
const Text = require('./Text.jsx');
const TypeConfig = require('./TypeConfig.jsx');

const Blocks = [
    {
        id: 'logo',
        component: Logo.Component,
        config: {
            Block: Logo.TypeConfig.panel.block(),
            Style: Logo.TypeConfig.panel.style()
        },
        display: 'Company Logo',
        image: ''
    },
    {
        id: 'companyAddress',
        component: CompanyAddress.Component,
        config: {
            Block: CompanyAddress.TypeConfig.panel.block(),
            Includes: CompanyAddress.TypeConfig.panel.includes(),
            Style: CompanyAddress.TypeConfig.panel.style()
        },
        display: 'Company Address',
        image: ''
    },
    {
        id: Name.Block.Separator,
        component: Separator.Component,
        config: {
            Block: Separator.TypeConfig.panel.block(),
            Style: Separator.TypeConfig.panel.style()
        },
        display: 'Separator',
        image: ''
    },
    {
        id: Name.Block.Text,
        component: Text.Component,
        config: {
            Block: Text.TypeConfig.panel.block(),
            Style: Text.TypeConfig.panel.style()
        },
        display: 'Text',
        image: ''
    }
];

const BlocksV2 = {
    get: (group) => {
        return [
            {
                id: Name.Block.Company.Logo,
                component: Logo.Component,
                config: {
                    Block: Logo.TypeConfigV2.panel.block(),
                    Style: Logo.TypeConfigV2.panel.style()
                },
                display: 'Logo',
                group,
                image: 'logo.svg'
            },
            {
                id: Name.Block.Company.ContactMeta,
                component: CompanyContactInfo.Component,
                config: {
                    Block: CompanyContactInfo.TypeConfig.panel.block(),
                    Style: CompanyContactInfo.TypeConfig.panel.style()
                },
                display: 'Company Contact Info',
                group,
                image: 'address.svg'
            },
            ...BlocksV2.content.get(group)
        ]
    },
    content: {
        get: (group) => {
            return [
                {
                    id: Name.Block.Text,
                    component: Text.ComponentV2,
                    config: {
                        Block: Text.TypeConfigV2.panel.block(),
                        Style: Text.TypeConfigV2.panel.style()
                    },
                    display: 'Text',
                    group,
                    image: 'text.png'
                },
                {
                    id: Name.Block.Separator,
                    component: Separator.Component,
                    config: {
                        Block: Separator.TypeConfigV2.panel.block(),
                        Style: Separator.TypeConfigV2.panel.style()
                    },
                    display: 'Divider',
                    group,
                    image: 'hr.png'
                }
            ]
        }
    },
    tokens: (id) => {
        switch (id) {
            case Name.Block.Company.ContactMeta:
                return CompanyContactInfo.Tokens();
        }
    }
}

module.exports = {
    Blocks,
    BlocksV2,
    TypeConfig
};